import { render, staticRenderFns } from "./ExtranetSetting.vue?vue&type=template&id=1f5c06ea&scoped=true"
import script from "./ExtranetSetting.vue?vue&type=script&lang=ts"
export * from "./ExtranetSetting.vue?vue&type=script&lang=ts"
import style0 from "./ExtranetSetting.vue?vue&type=style&index=0&id=1f5c06ea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5c06ea",
  null
  
)

export default component.exports